import get from 'lodash/get'
import { fromJS } from 'immutable'
import request from '../../request'
import { createAuthorization } from '../../auth'

/**
 * Get user rainbow categories from the server
 * @param {Object} options The options
 * @param {import('immutable').Map} options.auth The auth object
 * @param {String} options.server The server
 * @returns {Promise<import('immutable').Map>} The response body
 */
export async function getUserRainbowCategories (options = {}) {
  const { auth, uid, server } = options
  const res = await request
    .get(`${server}/v1/admin/user-RC`)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .query({ uid })
  const values = get(res, 'body', {})
  const rcValues = {
    rainbow: values,
  }
  return fromJS(rcValues)
}
